export default __webpack_public_path__ + "static/media/arrow.5aeb37db.svg";